/**
 * LogoutContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled logout container.
 */
const LogoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  left: ${72 * Screen.widthRatio}px;
  top: ${422 * Screen.widthRatio}px;
`;

export default withOpacity(LogoutContainer);
